import { TagI } from "constructs/Tag";

import { ReactComponent as AtomIcon } from "assets/icons/site/content/atom.svg";
import { ReactComponent as Castle } from "assets/icons/site/content/castle.svg";
import { ReactComponent as CosmicHorror } from "assets/icons/site/content/cosmic-horror.svg";
import { ReactComponent as Genius } from "assets/icons/site/content/traits/genius.svg";
import { ReactComponent as GeneralContent } from "assets/icons/site/content/general-content.svg"
import { ReactComponent as EroContent } from "assets/icons/site/content/ero-content.svg"
import { ReactComponent as Adventure } from "assets/icons/site/content/adventure.svg";
import { ReactComponent as Amnesia } from "assets/icons/site/content/amnesia.svg";
import { ReactComponent as MascotCharacter } from "assets/icons/site/content/mascot-character.svg";
// import { ReactComponent as Mystery } from "assets/icons/site/content/mystery.svg";

export const tags: Record<string, TagI> = {
  "1": {
    id: "4c10dbcc-e646-4040-b02c-658f2fa63afb",
    name: "General",
    icon: GeneralContent,
  },
  "2": {
    id: "2016e337-0e20-4dd1-93c0-f58a272987c2",
    name: "Ero",
    icon: EroContent,
  },
  "9d91ac31-7b40-4830-8514-c866e029a509": {
    id: "9d91ac31-7b40-4830-8514-c866e029a509",
    name: "Adventure",
    icon: Adventure,
  },
  "3": {
    id: "c11f7dd0-f626-459c-8b10-67eb664c5c51",
    name: "Science Fiction",
    icon: AtomIcon,
  },
  "4": {
    id: "13ff92d5-d658-47d4-8674-e18e782fb9bc",
    name: "Fantasy Fiction",
    icon: Castle,
  },
  "9": {
    id: "9",
    name: "Mystery",
    // icon: Mystery,
  },
  "0260ccc7-d8a4-4f01-a82a-0bc3abbc4f34": {
    id: "0260ccc7-d8a4-4f01-a82a-0bc3abbc4f34",
    name: "High Fantasy",
    // icon: <HighFantasy/>
  },
  "11": {
    id: "11",
    name: "Amnesia",
    icon: Amnesia,
  },
  "12": {
    id: "12",
    name: "Mascot Character",
    icon: MascotCharacter,
  },

  "16": {
    id: "16",
    name: "Mascot Character",
    // icon: TagIcon,
  },

  "24": {
    id: "24",
    name: "Mascot Character",
    // icon: MascotCharacter,
  },

  "f4cbd7f8-40cf-4ba3-a8de-ea2d6dc619d9": {
    id: "f4cbd7f8-40cf-4ba3-a8de-ea2d6dc619d9",
    name: "Dark Fantasy",
    // icon: <DarkFantasy/>
  },
  "b64d8299-b87a-47c3-b785-3c061553e74f": {
    id: "b64d8299-b87a-47c3-b785-3c061553e74f",
    name: "Low Fantasy",
    // icon: <LowFantasy/>
  },
  "63fa5ed0-6b11-482f-8ffc-e1c5486f2fe3": {
    id: "63fa5ed0-6b11-482f-8ffc-e1c5486f2fe3",
    name: "Historical Fantasy",
    // icon: <HistoricalFantasy/>
  },
  "ffa2c406-9b50-4486-91ab-ffb4625ae50a": {
    id: "ffa2c406-9b50-4486-91ab-ffb4625ae50a",
    name: "Ghost Story",
    // icon: <GhostStory/>
  },
  "e8c5f174-327c-43df-91bb-4a6d1b87e1f4": {
    id: "e8c5f174-327c-43df-91bb-4a6d1b87e1f4",
    name: "Occult Detective Story",
    // icon: <OccultDetectiveStory/>
  },
  "a823b058-7289-4eac-85fd-53f774c7939e": {
    id: "a823b058-7289-4eac-85fd-53f774c7939e",
    name: "Isekai",
    // icon: <Isekai/>
  },
  "a2f3816c-17db-4730-89f8-b390bddbd214": {
    id: "a2f3816c-17db-4730-89f8-b390bddbd214",
    name: "Kaiju",
    // icon: <Kaiju/>
  },
  "e920edac-c373-499a-b689-e12822c95b7f": {
    id: "e920edac-c373-499a-b689-e12822c95b7f",
    name: "Cosmic Horror",
    aliases: [ "Lovecraftian Horror"],
    icon: CosmicHorror,
  },
  "434c5626-2827-4167-9031-08b17547b207": {
    id: "434c5626-2827-4167-9031-08b17547b207",
    name: "Urban Fantasy",
    // icon: <UrbanFantasy/>
  },
  "aea41325-a297-45e6-b932-9a3da3dcb25a": {
    id: "aea41325-a297-45e6-b932-9a3da3dcb25a",
    name: "Fairy Tale",
    // icon: <FairyTale/>
  },
  "a9c412f9-896e-4026-91f3-7df9bfae3db6": {
    id: "a9c412f9-896e-4026-91f3-7df9bfae3db6",
    name: "DieselPunk",
    // icon: <DieselPunk/>
  },
  "a2808435-4083-4685-96d3-28e86ce1ca2c": {
    id: "a2808435-4083-4685-96d3-28e86ce1ca2c",
    name: "Cyberpunk",
    // icon: <Cyberpunk/>
  },
  "cc520e2e-3451-4b03-9806-aa4d487697ed": {
    id: "cc520e2e-3451-4b03-9806-aa4d487697ed",
    name: "Steampunk",
    // icon: <Steampunk/>
  },
  "cda2b9e5-ed64-481a-b404-9f51f46e76e9": {
    id: "cda2b9e5-ed64-481a-b404-9f51f46e76e9",
    name: "Mahou Shoujo - Magical Girl",
    // icon: <MahouShoujo/>
  },
  "c52514a5-6512-459c-ac84-ec9a71f01441": {
    id: "c52514a5-6512-459c-ac84-ec9a71f01441",
    name: "Dying Earth",
    // icon: <DyingEarth/>
  },
  "a316781b-b8d3-4922-9588-44ae2837d321": {
    id: "a316781b-b8d3-4922-9588-44ae2837d321",
    name: "Fairy Tale Parody",
    // icon: <FairyTaleParody/>
  },
  "dd9de5bf-b3c7-47f3-b7ff-4b03be0eae58": {
    id: "dd9de5bf-b3c7-47f3-b7ff-4b03be0eae58",
    name: "Gods and Demons",
    // icon: <GodsandDemons/>
  },
  "cad69123-4697-4191-932e-d385a8fdd50e": {
    id: "cad69123-4697-4191-932e-d385a8fdd50e",
    name: "Lost World",
    // icon: <LostWorld/>
  },
  "785dadaf-e32c-4c17-b0b0-4d2faa41e78b": {
    id: "785dadaf-e32c-4c17-b0b0-4d2faa41e78b",
    name: "Sword and Sorcery",
    // icon: <SwordandSorcery/>
  },
  "76f955d3-b4fe-450e-bde0-97b89c79b159": {
    id: "76f955d3-b4fe-450e-bde0-97b89c79b159",
    name: "Biopunk",
    // icon: <Biopunk/>
  },
  "c3011a8b-f5ed-4f9b-a88b-ba86125f17f6": {
    id: "c3011a8b-f5ed-4f9b-a88b-ba86125f17f6",
    name: "Climate Fiction",
    // icon: <ClimateFiction/>
  },
  "a3483ee1-e579-4585-b346-b70d79d6d367": {
    id: "a3483ee1-e579-4585-b346-b70d79d6d367",
    name: "Military Science Fiction",
    // icon: <MilitaryScienceFiction/>
  },
  "cfe873f6-036e-4fef-ad06-bfb4c02240af": {
    id: "cfe873f6-036e-4fef-ad06-bfb4c02240af",
    name: "Space Opera",
    // icon: <SpaceOpera/>
  },
  "0d828c77-2b13-4ba1-97f8-5abbca2e8754": {
    id: "0d828c77-2b13-4ba1-97f8-5abbca2e8754",
    name: "Space Western",
    // icon: <SpaceWestern/>
  },
  "383b219e-3519-4a50-870e-b698769090e0": {
    id: "383b219e-3519-4a50-870e-b698769090e0",
    name: "Alternate History",
    // icon: <AlternateHistory/>
  },
  "98d6ffd7-7e9f-462e-a354-8942645f3fc6": {
    id: "98d6ffd7-7e9f-462e-a354-8942645f3fc6",
    name: "Horror Fiction",
    // icon: <HorrorFiction/>
  },
  "5e10dfe2-42c5-41ca-a2fc-72c96f20b88b": {
    id: "5e10dfe2-42c5-41ca-a2fc-72c96f20b88b",
    name: "Amnesia",
    aliases: [ "Memory Loss"]
    // icon: <Amnesia/>
  },
  "e03aafcf-51af-4943-acb6-2f30d221b8e4": {
    id: "e03aafcf-51af-4943-acb6-2f30d221b8e4",
    name: "Pandemic",
    // icon: <Pandemic/>
  },
  "50966f6f-d254-4dd2-b0ed-97dff1f4c106": {
    id: "50966f6f-d254-4dd2-b0ed-97dff1f4c106",
    name: "Virus",
    // icon: <Virus/>
  },
  "cd8111ab-f80e-4bf0-a0fd-d55061ff7bf8": {
    id: "cd8111ab-f80e-4bf0-a0fd-d55061ff7bf8",
    name: "Dystopia",
    // icon: <Dystopia/>
  },
  "b798a309-c1f7-49cf-9cca-5e7b0a6ba624": {
    id: "b798a309-c1f7-49cf-9cca-5e7b0a6ba624",
    name: "Utopia",
    // icon: <Utopia/>
  },
  "5b5d7d56-96cf-4d40-a553-068f240eddae": {
    id: "5b5d7d56-96cf-4d40-a553-068f240eddae",
    name: "Mascot",
    // icon: <Mascot/>
  },
  "18b7ffaa-6116-4878-922e-cc62f6e332ee": {
    id: "18b7ffaa-6116-4878-922e-cc62f6e332ee",
    name: "Hacking",
    // icon: <Hacking/>
  },
  "b87f5256-0afa-4abf-a2a1-4b38d5e8b645": {
    id: "b87f5256-0afa-4abf-a2a1-4b38d5e8b645",
    name: "Action",
    // icon: <Action/>
  },
  "564438b1-f501-4953-aa35-9a33fcbfde7e": {
    id: "564438b1-f501-4953-aa35-9a33fcbfde7e",
    name: "Super Powers",
    // icon: <SuperPowers/>
  },
  "717ada38-a3ac-4a11-904f-afddc24cec5b": {
    id: "717ada38-a3ac-4a11-904f-afddc24cec5b",
    name: "Ecchi",
    // icon: <Ecchi/>
  },
  "f16a7f99-1b07-48fd-a4e5-34704542bc01": {
    id: "f16a7f99-1b07-48fd-a4e5-34704542bc01",
    name: "Kings",
    // icon: <Kings/>
  },
  "bcf37bf9-c0de-424b-baf4-18874293dab7": {
    id: "bcf37bf9-c0de-424b-baf4-18874293dab7",
    name: "Abuse",
    // icon: <Abuse/>
  },
  "7009cee0-70c8-4567-bcac-57f59002205e": {
    id: "7009cee0-70c8-4567-bcac-57f59002205e",
    name: "Demons/Monsters",
    // icon: <DemonsandMonsters/>
  },
  // NOTE: This one is for testing and should be considered a trait instead
  "14": {
    id: "ea88c16d-cfc6-4dd5-a3bc-0be7308e75d6",
    name: "Genius",
    icon: Genius,
  }
}